const AREAS = ["Indirapuram", "Raj Nagar", "Vaishali", "Vasundhara", "Crossings Republik", "Kaushambi", "Delhi NCR"];

export const Marquee = () => (
  <div className="bg-ink py-5 overflow-hidden" data-testid="areas-marquee" aria-label="Areas served">
    <div className="flex w-max animate-marquee gap-0 hover:[animation-play-state:paused]">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {AREAS.map((a) => (
            <span key={`${dup}-${a}`} className="flex items-center">
              <span className="font-serif italic text-xl sm:text-2xl text-paper/90 px-8 whitespace-nowrap">{a}</span>
              <span className="text-brass text-lg">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
